import { useParams, Navigate } from "react-router-dom";
import { locationBySlug } from "../../data/locationData";
import LocationPage from "./LocationPage";

export default function DynamicLocationPage() {
  const { slug } = useParams();
  const data = locationBySlug[slug];

  if (!data) return <Navigate to="/" replace />;

  return <LocationPage {...data} />;
}
